import {ICapture, IDeleteReplayResponse, IRepeatReplayResponse, IGetReplaysResponse, IPostReplayResponse, IReplay, IReplayConfig} from "interfaces";
import {axiosAPI} from "./API";
import { TaskState } from "enums";

// Singleton for interacting with Replays
class _ReplayService {

    public allReplays: IReplay[] = [];

    public getAll = (): Promise<IGetReplaysResponse> => {

        return axiosAPI.get<IGetReplaysResponse>("/replay")
            .then((resp) => {
                let replaysResponse = resp.data;
                // save to cache
                this.allReplays = replaysResponse.data;
                // filter deleted
                this.allReplays = this.allReplays.filter(r => r.status != TaskState.Deleted);
                // sort
                this.allReplays.sort((a, b) => {
                    // special cases to make sure running/pending tasks go to the top
                    // since they have a start time of 0 but we want to sort descending
                    if (a.startTime == 0) return -1;
                    if (b.startTime == 0) return 1;
                    return b.startTime - a.startTime;
                })
                return replaysResponse;
            })
            .catch((err) => {
                console.error("Error getting all replays: ", err);
                throw err;
            });
    }

    public postReplay = (name: string, capture: ICapture, config: IReplayConfig): Promise<IPostReplayResponse> => {

        let data = {
            'replayName': name,
            'replayConfigUUID': config.replayConfigUUID,
            'captureUUID': capture.captureUUID
        };

        return axiosAPI.post<IPostReplayResponse>('/replay', data)
            .then((resp) => {
                let newReplay: IReplay = {
                    name: name,
                    replayUUID: resp.data.data.replayUUID,
                    configUUID: config.replayConfigUUID,
                    captureUUID: capture.captureUUID,
                    status: TaskState.Pending,
                    startTime: 0,
                    endTime: 0,
                    timesRepeated: 0,
                };
                // save to cache
                this.allReplays.unshift(newReplay);
                return resp.data;
            })
            .catch((err) => {
                console.error("Error posting replay: ", err);
                throw err;
            });
    }

    public deleteReplay = (replay: IReplay): Promise<IDeleteReplayResponse> => {

        let url = `/replay/${replay.replayUUID}`;
        if (replay.status === TaskState.Success || replay.status === TaskState.Cancelled) url += "?delete=true";

        return axiosAPI.delete<IDeleteReplayResponse>(url)
            .then((resp) => {
                if (resp.data.data.status === TaskState.Deleted) {
                    // remove from list
                    this.allReplays = this.allReplays.filter(r => r.replayUUID != replay.replayUUID);
                    // OR change item status
                    // this.allReplays[this.allReplays.findIndex(r => r.replayUUID === replay.replayUUID)].status = TaskState.Deleted;
                }
                if (resp.data.data.status === TaskState.Cancelled) {
                    this.allReplays[this.allReplays.findIndex(r => r.replayUUID === replay.replayUUID)].status = TaskState.Cancelled;
                }
                return resp.data;
            })
            .catch((err) => {
                console.error("Error deleting replay: ", err);
                throw err;
            });
    }

    public repeatReplay = (replay: IReplay): Promise<IRepeatReplayResponse> => {

        const url = `/replay/${replay.replayUUID}`;

        return axiosAPI.post<IRepeatReplayResponse>(url)
            .then((resp) => {
                const repeatedReplay = this.allReplays[this.allReplays.findIndex(r => r.replayUUID === replay.replayUUID)];

                repeatedReplay.timesRepeated += 1;
                repeatedReplay.startTime = 0;
                repeatedReplay.endTime = 0;
                repeatedReplay.status = TaskState.Pending;

                return resp.data;
            })
            .catch((err) => {
                console.error("Error re-initializing replay: ", err);
                throw err;
            });
    }
}

export const ReplayService = new _ReplayService();